import { styled } from '@mui/material';
import { ReactNode, forwardRef } from 'react';

type Props = {
  children: ReactNode;
};

export const PageHeaderContainer = forwardRef<HTMLDivElement, Props>(
  ({ children, ...rest }: Props, ref) => {
    return (
      <StyledContainer ref={ref} {...rest}>
        {children}
      </StyledContainer>
    );
  },
);

const StyledContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(1.5),
  borderTop: `1px solid ${theme.palette.background.default}`,
  borderBottom: `1px solid ${theme.palette.divider}`,
}));
